import * as T from '../../../../../../components/Table'
import { ReferenteItem } from './ReferenteItem'

export function ReferenteResumo({ list, control }) {
  return (
    <T.Table borderCollapse="collapse" variant="striped">
      <T.Thead>
        <T.Th>REFERENTE Á</T.Th>
        <T.Th>VALOR</T.Th>
        <T.Th>DEDUÇÃO</T.Th>
      </T.Thead>
      <T.Tbody>
        {list?.map((item, index) => (
          <ReferenteItem key={index} item={item} control={control} isDisabled={index === 6 && index === list.length - 1} />
        ))}
      </T.Tbody>
    </T.Table>
  )
}
